import Breadcrumb from "@/components/BreadCrumb";
import Layout from "@/components/layout";
import Head from "next/head";

export default function Refund() {
  return (
    <>
      <Head>
        <title>Refund Policy | Tradewise</title>
        <meta
          name="description"
          content="Review Tradewise's Refund Policy to understand how we handle cancellations and refunds for our trading courses. Your satisfaction is our priority."
        />
      </Head>
      <Layout>
        <Breadcrumb />
        <section className="p-5 flex flex-col items-center">
          <div className=" max-w-[700px]">
            <div className="py-4">
              <h1>Refund Policy</h1>
              <div className="mt-10 prose">
                <p>
                  Please write to us at{" "}
                  <a href="mailto: ceo@thefuture.university">
                    ceo@thefuture.university
                  </a>{" "}
                  if you want to reach out with a request for refund. However,
                  please ensure that you comply to all of the following:
                </p>
                <ul className=" list-disc pl-10 pt-5 flex flex-col gap-2">
                  <li>
                    Refund will be credited to the original mode of payment
                    within 3-4 working days.
                  </li>
                  <li>
                    If you have paid a token amount for the bootcamp, you will
                    not be eligible for a refund for the token amount as this
                    price is paid upfront to block your seat ahead, unless you
                    cancel 14 days before the batch start date.
                  </li>
                  <li>
                    100% refund is possible provided you have not attended any
                    session and cancel 14 days prior to batch start date.
                  </li>
                  <li>
                    If you cancel your seat between 3-14 days before the batch
                    start date, a 50% refund is possible.
                  </li>
                  <li>
                    No refund is possible 0-3 days before the batch start date,
                    or once the batch has started.
                  </li>
                  <li>
                    No refund/cancellation is possible once the course has
                    started.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </>
  );
}
